import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertComponent } from 'src/app/structure/alert/alert.component';
import { InvestmentService } from 'src/app/services/investment.service';
declare var $: any;
import * as _ from 'lodash';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { CustomValidation } from 'src/app/helpers/customValidation';
import { DocumentManagementMasterService } from 'src/app/services/document-management-master.service';
import { CommonFunction } from 'src/app/helpers/commonFunction';
@Component({
  selector: 'app-investment',
  templateUrl: './investment.component.html',
  styleUrls: ['./investment.component.css']
})
export class InvestmentComponent implements OnInit {

  public environmentSettings: any;
  public downloadAllLink: string = "documentManagement/downloadSingleFileOnID/";
  investmentForm: FormGroup;
  token: any = localStorage.getItem('token')

  ecsList: any = [];

  editInvestmentData: any = [];
  DateOfAcquisition: any;
  DateOfBoardModel: any;
  DateOfShareholderResolutionModel: any;
  dateOftitleModel: any;
  ParticularId: any;
  DateOfAcquisitionModel: any;
  addBtn = true;
  boardCtcUpload: Array<File>;
  shareholderCtcUpload: Array<File>;
  boardChangedName: any;
  boardFileOrignalName: any;
  shareholderChangedName: any;
  shareholderFileOrignalName: any;
  boardCtc: any;
  shareholderCtc: any;
  boardCtcDocId: any;
  shareholderCtcDocId: any;
  boardFileAvailable = false;
  shareholderFileAvailable = false;
  canRevertBoardFile: boolean;
  canRevertShareholderFile: boolean;
  disabledOnclick: boolean;
  fileExtension: boolean = true;
  checkFileExtension: boolean = true;
  // token: any;

  constructor(private InvestmentService: InvestmentService, private activatedRoute: ActivatedRoute,
    private alert: AlertComponent, private customValidation: CustomValidation,private router: Router,
    private documentManagementMasterService: DocumentManagementMasterService, private commonFunction:CommonFunction) { }

  ngOnInit() {

    // this.token = localStorage.getItem('token');
    this.investmentForm = new FormGroup({
      nameOfPerson: new FormControl('', [Validators.required, Validators.pattern("^[a-zA-Z0-9' ]*$"), this.customValidation.noWhitespaceValidator]),
      DateOfAcquisition: new FormControl('', [Validators.required]),
      descriptionOfProperties: new FormControl('', []),
      listOfdocuments: new FormControl('', []),
      reasons: new FormControl('', []),
      DateOfBoard: new FormControl('', []),
      boardCtc: new FormControl('', []),
      DateOfShareholderResolution: new FormControl('', []),
      shareholderCtc: new FormControl('', []),
      quantumOfInvestment: new FormControl('', []),
      dateOftitle: new FormControl('', []),
      descriptionOftitle: new FormControl('', []),
      remarks: new FormControl('', []),
    })
    this.activatedRoute.params.subscribe(params => {
      if (params['particularId'] != undefined) {
        this.addBtn = false;
        this.ParticularId = params['particularId'];
        this.getInvestmentById(this.ParticularId);
      } else {

      }
    })
  }

  setDate(date) {
    if (date != "" && date != null) {
      return date.month + "-" + date.day + "-" + date.year;
    }
    return null;
  }

  boardFileChangeEvent(fileInput: any) {
  
      console.log("this.boardCtcUpload", this.boardCtcUpload)
    var checkfile = this.commonFunction.checkFileExtension(fileInput);
     if(checkfile){
      this.boardCtcUpload = <Array<File>>fileInput.target.files;
      this.fileExtension = true;
     }else{
      this.fileExtension = false;
     }
    console.log("fileExtension", this.fileExtension);
  
    fileInput = null;
    this.canRevertBoardFile = false;
  }
  shareHolderFileChangeEvent(fileInput: any) {
  
    var checkfile = this.commonFunction.checkFileExtension(fileInput);
    if(checkfile){
      this.shareholderCtcUpload = <Array<File>>fileInput.target.files;
     this.checkFileExtension = true;
    }else{
     this.checkFileExtension = false;
    }
    fileInput = null;
    this.canRevertShareholderFile = false;
  }

  makeBoardFileRequest(url: string, params: Array<string>, files: Array<File>) {
    return new Promise((resolve, reject) => {
      var formData: any = new FormData();
      var xhr = new XMLHttpRequest();
      var now = Date.now();
      for (var i = 0; i < files.length; i++) {
        var name = now + '-' + files[i].name.replace(',', '');
        name = name.replace(new RegExp('\\(', 'g'), '');
        name = name.replace(new RegExp('\\)', 'g'), '');
        formData.append("file", files[i], name);
        this.boardFileOrignalName = files[i].name.replace(',', '');

        this.boardChangedName = name;
      }
      xhr.onreadystatechange = function () {
        if (xhr.readyState == 4) {
          if (xhr.status == 200) {
            resolve(JSON.parse(xhr.response));
          } else {
            reject(xhr.response);
          }
        }
      }
      xhr.open("POST", url, true);
      var token = localStorage.getItem('token')
      xhr.setRequestHeader('x-access-token', token)
      xhr.send(formData);
    });
  }

  uploadBoardCtc() {
    var file = this.boardCtcUpload;
    return this.makeBoardFileRequest(environment.pssServerUrl + "documentManagement/fileUpload/", [], file).then((result) => {
      if (result) {
        var document = {
          "DocumentManagement": {
            "DocumentName": Date.now() + " - Document (Board CTC)",
            "DateOfDocument": new Date(),
            "CompletedDate": null,
            "MeetingTypeID": null,
            "ParentDocumentTypeID": null,
            "ParentSubDocumentTypeID": null,
            "DirectorKmp": "None",
            "DirectorID": null,
            "KMPID": null,
            "Remarks": "",
            "Overwrite": false,
            "Upload": this.boardChangedName,
            "OriginalFileName": this.boardFileOrignalName,
            "FilePath": "",
            "CreatedBy": null,
            "CreatedDate": new Date(),
            "LastUpdateFiles": new Date(),
            "ModifiedBy": null,
            "ModifiedDate": null,
          }
        }
        return this.documentManagementMasterService.addDocumentManagement(document)
          .toPromise().then(res => { return Promise.resolve(res); })

      }
    }, (error) => {
      this.alert.error("Oops, Something Went Wrong");
      return false;
    });
  }

  makeShareholderFileRequest(url: string, params: Array<string>, files: Array<File>) {
    return new Promise((resolve, reject) => {
      var formData: any = new FormData();
      var xhr = new XMLHttpRequest();
      var now = Date.now();
      for (var i = 0; i < files.length; i++) {
        var name = now + '-' + files[i].name.replace(',', '');
        name = name.replace(new RegExp('\\(', 'g'), '');
        name = name.replace(new RegExp('\\)', 'g'), '');
        formData.append("file", files[i], name);
        this.shareholderFileOrignalName = files[i].name.replace(',', '');

        this.shareholderChangedName = name;
      }
      xhr.onreadystatechange = function () {
        if (xhr.readyState == 4) {
          if (xhr.status == 200) {
            resolve(JSON.parse(xhr.response));
          } else {
            reject(xhr.response);
          }
        }
      }
      xhr.open("POST", url, true);
      var token = localStorage.getItem('token')
      xhr.setRequestHeader('x-access-token', token)
      xhr.send(formData);
    });
  }

  uploadShareholderCtc() {
    var file = this.shareholderCtcUpload;
    return this.makeShareholderFileRequest(environment.pssServerUrl + "documentManagement/fileUpload/", [], file).then((result) => {
      if (result) {
        var document = {
          "DocumentManagement": {
            "DocumentName": Date.now() + " - Document (Board CTC)",
            "DateOfDocument": new Date(),
            "CompletedDate": null,
            "MeetingTypeID": null,
            "ParentDocumentTypeID": null,
            "ParentSubDocumentTypeID": null,
            "DirectorKmp": "None",
            "DirectorID": null,
            "KMPID": null,
            "Remarks": "",
            "Overwrite": false,
            "Upload": this.shareholderChangedName,
            "OriginalFileName": this.shareholderFileOrignalName,
            "FilePath": "",
            "CreatedBy": null,
            "CreatedDate": new Date(),
            "LastUpdateFiles": new Date(),
            "ModifiedBy": null,
            "ModifiedDate": null,
          }
        }
        return this.documentManagementMasterService.addDocumentManagement(document)
          .toPromise().then(res => { return Promise.resolve(res); })

      }
    }, (error) => {
      this.alert.error("Oops, Something Went Wrong");
      return false;
    }
    );
  }

  saveInvestmentData() {
    this.disabledOnclick = true;
    var investmentObject = {
      nameOfPerson: this.investmentForm.controls.nameOfPerson.value.trim(),
      DateOfAcquisition: this.setDate(this.investmentForm.controls.DateOfAcquisition.value),
      descriptionOfProperties: this.investmentForm.controls.descriptionOfProperties.value,
      listOfdocuments: this.investmentForm.controls.listOfdocuments.value,
      reasons: this.investmentForm.controls.reasons.value,
      DateOfBoard: this.setDate(this.investmentForm.controls.DateOfBoard.value),
      DateOfShareholderResolution: this.setDate(this.investmentForm.controls.DateOfShareholderResolution.value),
      quantumOfInvestment: this.investmentForm.controls.quantumOfInvestment.value,
      dateOftitle: this.setDate(this.investmentForm.controls.dateOftitle.value),
      descriptionOftitle: this.investmentForm.controls.descriptionOftitle.value,
      remarks: this.investmentForm.controls.remarks.value,
      boardCtcFilename: null,
      boardCtcDocId: null,
      shareholderCtcFilename: null,
      shareholderCtcDocId: null
    }
    var self = this;
    if (self.boardCtcUpload != undefined && self.shareholderCtcUpload != undefined) {
      self.uploadBoardCtc().then(function (boardResponse:any) {
        if (boardResponse.status == 0) {
          investmentObject.boardCtcFilename = self.boardFileOrignalName;
          investmentObject.boardCtcDocId = boardResponse.result._id;
          if (self.shareholderCtcUpload != undefined) {
            self.uploadShareholderCtc().then(function (shareholderResponse:any) {
              if (shareholderResponse.status == 0) {
                investmentObject.shareholderCtcFilename = self.shareholderFileOrignalName;
                investmentObject.shareholderCtcDocId = shareholderResponse.result._id;
                self.InvestmentService.addInvestmentData(investmentObject).subscribe(response => {
                  self.disabledOnclick = false;
                  if (response.status == 0) {
                    self.alert.successWithOk(response.message, 'investment-list')
                  } else {
                    if(response.err_fields){
                      self.alert.error(response.err_fields + ' fields are required or invalid.');
                    }else{
                      self.alert.error(response.message);
                    }
                  }
                })
              }
            })
          }
        }else{
          self.alert.error("Oops, Something Went Wrong");
        }
      })
    } else if (self.boardCtcUpload != undefined && self.shareholderCtcUpload == undefined) {
      self.uploadBoardCtc().then(function (boardResponse:any) {
        if (boardResponse.status == 0) {
          investmentObject.boardCtcFilename = self.boardFileOrignalName;
          investmentObject.boardCtcDocId = boardResponse.result._id;
          self.InvestmentService.addInvestmentData(investmentObject).subscribe(response => {
            self.disabledOnclick = false;
            if (response.status == 0) {
              self.alert.successWithOk(response.message, 'investment-list')
            } else {
              if(response.err_fields){
                self.alert.error(response.err_fields + ' fields are required or invalid.');
              }else{
                self.alert.error(response.message);
              }
            }
          })
        }
      })
    } else if (self.boardCtcUpload == undefined && self.shareholderCtcUpload != undefined) {
      self.uploadShareholderCtc().then(function (shareholderResponse:any) {
        if (shareholderResponse.status == 0) {
          investmentObject.shareholderCtcFilename = self.shareholderFileOrignalName;
          investmentObject.shareholderCtcDocId = shareholderResponse.result._id;
          self.InvestmentService.addInvestmentData(investmentObject).subscribe(response => {
            self.disabledOnclick = false;
            if (response.status == 0) {
              self.alert.successWithOk(response.message, 'investment-list')
            } else {
                if(response.err_fields){
                  self.alert.error(response.err_fields + ' fields are required or invalid.');
                }else{
                  self.alert.error(response.message);
                }
            }
          })
        }
      })
    } else if (self.boardCtcUpload == undefined && self.shareholderCtcUpload == undefined) {
      self.InvestmentService.addInvestmentData(investmentObject).subscribe(response => {
        self.disabledOnclick = false;
        if (response.status == 0) {
          self.alert.successWithOk(response.message, 'investment-list')
        } else {
            if(response.err_fields){
              self.alert.error(response.err_fields + ' fields are required or invalid.');
            }else{
              self.alert.error(response.message);
            }
        }
      })
    }

  }
  setFormatDate(date) {
    if (date != null) {
      return new Date(date);
    }
    return null;
  }

  getInvestmentById(particularId) {
    this.InvestmentService.updateinvestment(particularId).subscribe(response => {
      console.log(response);
      this.editInvestmentData = response.data[0];
      this.investmentForm.controls.nameOfPerson.setValue(this.editInvestmentData.nameOfPerson);
      this.investmentForm.controls.DateOfAcquisition.setValue(this.editInvestmentData.DateOfAcquisition);
      this.investmentForm.controls.descriptionOfProperties.setValue(this.editInvestmentData.descriptionOfProperties);
      this.investmentForm.controls.listOfdocuments.setValue(this.editInvestmentData.listOfdocuments);
      this.investmentForm.controls.reasons.setValue(this.editInvestmentData.reasons);
      this.investmentForm.controls.DateOfBoard.setValue(this.editInvestmentData.DateOfBoard);
      // this.investmentForm.controls.uploadctc1.setValue(this.editInvestmentData.uploadctc1);
      this.investmentForm.controls.DateOfShareholderResolution.setValue(this.editInvestmentData.DateOfShareholderResolution);
      // this.investmentForm.controls.uploadctc2.setValue(this.editInvestmentData.uploadctc2);
      this.investmentForm.controls.quantumOfInvestment.setValue(this.editInvestmentData.quantumOfInvestment);
      this.investmentForm.controls.dateOftitle.setValue(this.editInvestmentData.dateOftitle);
      this.investmentForm.controls.descriptionOftitle.setValue(this.editInvestmentData.descriptionOftitle);
      this.investmentForm.controls.remarks.setValue(this.editInvestmentData.remarks);


      if (this.editInvestmentData.DateOfAcquisition != null) {
        let dt = new Date(this.setFormatDate(this.editInvestmentData.DateOfAcquisition));
        this.DateOfAcquisitionModel = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
      }
      if (this.editInvestmentData.DateOfBoard != null) {
        let dt = new Date(this.setFormatDate(this.editInvestmentData.DateOfBoard));
        this.DateOfBoardModel = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
      }
      if (this.editInvestmentData.DateOfShareholderResolution != null) {
        let dt = new Date(this.setFormatDate(this.editInvestmentData.DateOfShareholderResolution));
        this.DateOfShareholderResolutionModel = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
      }
      if (this.editInvestmentData.dateOftitle != null) {
        let dt = new Date(this.setFormatDate(this.editInvestmentData.dateOftitle));
        this.dateOftitleModel = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
      }
      if (this.editInvestmentData.boardCtcFilename != null) {
        this.boardFileAvailable = true;
        this.canRevertBoardFile = false;
        this.boardCtc = this.editInvestmentData.boardCtcFilename;
        this.boardCtcDocId = this.editInvestmentData.boardCtcDocId;
      }
      if (this.editInvestmentData.shareholderCtcFilename != null) {
        this.shareholderFileAvailable = true;
        this.canRevertShareholderFile = false;
        this.shareholderCtc = this.editInvestmentData.shareholderCtcFilename;
        this.shareholderCtcDocId = this.editInvestmentData.shareholderCtcDocId;
      }
    })
  }

  addBoardFilesOnUpdate() {
    this.boardFileAvailable = false;
    this.canRevertBoardFile = true;
  }

  addShareholderFilesOnUpdate() {
    this.shareholderFileAvailable = false;
    this.canRevertShareholderFile = true;
  }

  updateBankAccountParticulars(_id) {
    this.disabledOnclick = true;
    var investmentObject = {
      nameOfPerson: this.investmentForm.controls.nameOfPerson.value,
      DateOfAcquisition: this.setDate(this.investmentForm.controls.DateOfAcquisition.value),
      descriptionOfProperties: this.investmentForm.controls.descriptionOfProperties.value,
      listOfdocuments: this.investmentForm.controls.listOfdocuments.value,
      reasons: this.investmentForm.controls.reasons.value,
      DateOfBoard: this.setDate(this.investmentForm.controls.DateOfBoard.value),
      DateOfShareholderResolution: this.setDate(this.investmentForm.controls.DateOfShareholderResolution.value),
      quantumOfInvestment: this.investmentForm.controls.quantumOfInvestment.value,
      dateOftitle: this.setDate(this.investmentForm.controls.dateOftitle.value),
      descriptionOftitle: this.investmentForm.controls.descriptionOftitle.value,
      remarks: this.investmentForm.controls.remarks.value,
      boardCtcFilename: this.boardCtc,
      boardCtcDocId: this.boardCtcDocId,
      shareholderCtcFilename: this.shareholderCtc,
      shareholderCtcDocId: this.shareholderCtcDocId
    }

    var self = this;
    if (self.boardCtcUpload != undefined && self.shareholderCtcUpload != undefined) {
      self.uploadBoardCtc().then(function (boardResponse:any) {
        if (boardResponse.status == 0) {
          investmentObject.boardCtcFilename = self.boardFileOrignalName;
          investmentObject.boardCtcDocId = boardResponse.result._id;
          if (self.shareholderCtcUpload != undefined) {
            self.uploadShareholderCtc().then(function (shareholderResponse:any) {
              if (shareholderResponse.status == 0) {
                investmentObject.shareholderCtcFilename = self.shareholderFileOrignalName;
                investmentObject.shareholderCtcDocId = shareholderResponse.result._id;
                self.InvestmentService.updateInvestmentAccountParticulars(investmentObject, self.ParticularId).subscribe(response => {
                  self.disabledOnclick = false;
                  if (response.status == 0) {
                    self.alert.successWithOk(response.message, 'investment-list')
                  } else {
                    // self.alert.error(response.message);
                    if(response.err_fields){
                      self.alert.error(response.err_fields + ' fields are required or invalid.');
                    }else{
                      self.alert.error(response.message);
                    }
                  }
                })
              }
            })
          }
        }
      })
    } else if (self.boardCtcUpload != undefined && self.shareholderCtcUpload == undefined) {
      self.uploadBoardCtc().then(function (boardResponse:any) {
        if (boardResponse.status == 0) {
          investmentObject.boardCtcFilename = self.boardFileOrignalName;
          investmentObject.boardCtcDocId = boardResponse.result._id;
          self.InvestmentService.updateInvestmentAccountParticulars(investmentObject, self.ParticularId).subscribe(response => {
            self.disabledOnclick = false;
            if (response.status == 0) {
              self.alert.successWithOk(response.message, 'investment-list')
            } else {
              // self.alert.error(response.message);
              if(response.err_fields){
                self.alert.error(response.err_fields + ' fields are required or invalid.');
              }else{
                self.alert.error(response.message);
              }
              
            }
          })
        }
      })
    } else if (self.boardCtcUpload == undefined && self.shareholderCtcUpload != undefined) {
      self.uploadShareholderCtc().then(function (shareholderResponse:any) {
        if (shareholderResponse.status == 0) {
          investmentObject.shareholderCtcFilename = self.shareholderFileOrignalName;
          investmentObject.shareholderCtcDocId = shareholderResponse.result._id;
          self.InvestmentService.updateInvestmentAccountParticulars(investmentObject, self.ParticularId).subscribe(response => {
            self.disabledOnclick = false;
            if (response.status == 0) {
              self.alert.successWithOk(response.message, 'investment-list')
            } else {
              // self.alert.error(response.message);
              if(response.err_fields){
                self.alert.error(response.err_fields + ' fields are required or invalid.');
              }else{
                self.alert.error(response.message);
              }
            }
          })
        }
      })
    } else if (self.boardCtcUpload == undefined && self.shareholderCtcUpload == undefined) {
      self.InvestmentService.updateInvestmentAccountParticulars(investmentObject, self.ParticularId).subscribe(response => {
        self.disabledOnclick = false;
        if (response.status == 0) {
          self.alert.successWithOk(response.message, 'investment-list')
        } else {
          // self.alert.error(response.message);
          if(response.err_fields){
            self.alert.error(response.err_fields + ' fields are required or invalid.');
          }else{
            self.alert.error(response.message);
          }
        }
      })
    }
  }

  downloadCtcDoc(id) {
    // window.location.href = environment.pssUrl + this.downloadAllLink + id;
    window.location.href = environment.pssServerUrl + this.downloadAllLink + id + '/' + this.token;
  }

  revertBoardFile() {
    this.canRevertBoardFile = false;
    this.boardFileAvailable = true;
  }

  revertShareholderFile() {
    this.canRevertShareholderFile = false;
    this.shareholderFileAvailable = true;
  }
  back(){
    this.router.navigate(
      [{ outlets: { 'structure-outlet': ['investment-list']  } }],
      { relativeTo: this.activatedRoute.parent });
  }
  generateOutput() {
    var object = {
      id: this.ParticularId,
      fromDate: null,
      toDate: null,
      name: null
    }
    this.InvestmentService.generateInvestmentDocument(object).subscribe(response => {
      if (response.status == 0) {
        this.alert.success(response.message);
        var self = this;
        setTimeout(function () {
          self.downloadDocument(self.ParticularId);
          setTimeout(function () {
            self.downloadPdfDocument(self.ParticularId);
          }, 1000);
        }, 1000);
      } else {
        this.alert.error(response.message);
      }
    })
  }

  downloadDocument(id) {
    this.InvestmentService.downloadInvestmentFile(id, 'Single');
  }
  downloadPdfDocument(id) {
    this.InvestmentService.downloadInvestmentPdfFile(id, 'Single');
  }
}

